import { logout } from "./auth";

// src/api.js
const RAW_BASE = process.env.REACT_APP_API_URL || "";
const API_BASE = RAW_BASE.trim().replace(/\/+$/, "");
const buildUrl = (path) => new URL(path, API_BASE + "/").toString();

// Función auxiliar para leer perfil sin importar auth.js (evita ciclos)
function getProfileId() {
  try {
    const raw = sessionStorage.getItem("active_profile");
    if (raw) return JSON.parse(raw).id;
  } catch { }
  return null;
}

function getProfileRole() {
  try {
    const raw = sessionStorage.getItem("active_profile");
    if (raw) return JSON.parse(raw).rol;
  } catch { }
  return null;
}

export function getEmpresaId() {
  // 1) prioridad: user.empresa_id guardado al hacer login
  try {
    const u = sessionStorage.getItem("user");
    if (u) {
      const parsed = JSON.parse(u);
      const eid = Number(parsed?.empresa_id);
      if (!Number.isNaN(eid) && eid > 0) return eid;
    }
  } catch { }

  // 2) compat: clave vieja "empresa_id" si existiera
  try {
    const v = sessionStorage.getItem("empresa_id");
    const eid = Number(v);
    if (!Number.isNaN(eid) && eid > 0) return eid;
  } catch { }

  return null;
}

export async function apiFetch(path, init = {}) {
  const url = buildUrl(path);
  const headers = new Headers(init.headers || {});

  // 1. Header de Empresa
  const empresaId = getEmpresaId();
  if (!empresaId) {
    await logout();
    window.location.reload();
    throw new Error("No hay empresa activa");
  }
  if (!headers.has("X-Empresa-Id")) {
    headers.set("X-Empresa-Id", String(empresaId));
  }

  // 2. NUEVO: Header de Perfil (Vendedor/Admin)
  const profileId = getProfileId();
  if (profileId && !headers.has("X-Profile-Id")) {
    headers.set("X-Profile-Id", String(profileId));
  }
  const profileRole = getProfileRole();
  if (profileRole && !headers.has("X-Profile-Rol")) {
    headers.set("X-Profile-Rol", String(profileRole));
  }

  if (init.body && !(init.body instanceof FormData) && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  const res = await fetch(url, { credentials: "include", ...init, headers });

  if (res.status === 401) {
    await logout();
    window.location.reload();
    throw new Error("Sesión no autorizada");
  }

  return res;
}
